import { useEffect, useState } from 'react'
import { useLanguage } from '@/hooks/useLanguage'
import { betaT } from '../locale'
import { BetaThankYouFooter } from './BetaThankYouFooter'

export const BetaThankYou = () => {
  const { language } = useLanguage()
  const l = betaT[language]
  const [lifted, setLifted] = useState(false)

  useEffect(() => {
    const id = setTimeout(() => setLifted(true), 3500)
    return () => clearTimeout(id)
  }, [])

  // white by design: renders on the fixed-dark Beta hero (BetaLayout), not app surface
  return (
    <div className="relative">
      <div
        className="flex flex-col items-center text-center transition-all duration-1000 ease-in-out"
        style={{ transform: lifted ? 'translateY(0)' : 'translateY(40px)' }}
      >
        <img src="/wait-list-success.webp" alt="" className="w-[84px] h-[84px] mb-4 mx-auto" />
        <h2 className="text-xl sm:text-2xl font-semibold text-white mb-2">{l.thankYou}</h2>
        <p className="text-sm text-white/60 mb-1">{l.thankDesc}</p>
      </div>
      <BetaThankYouFooter />
    </div>
  )
}
